import { RootModel } from '@pc/models';
import { createModel } from '@rematch/core';
import { Api, ApiConfig } from '@shared/api';
import { ApiUserGroupIterface, SetPermissionsStateType, TableItetmType, FolderTree } from './interface';
import { setLocal, getLocal, STORAGE_KEY } from '@shared/components/localStorage';
import { generateFolderTree } from './utils';
import { isEmpty } from 'lodash';

const SetPermissionsModel = createModel<RootModel>()({
  name: 'SetPermissionsModel',
  state: {
    groups: [],
    tableData: [],
    alerTableData: '',
  } as any as SetPermissionsStateType,
  reducers: {
    setState(state, payload: Partial<SetPermissionsStateType>) {
      return {
        ...state,
        ...payload,
      };
    },
    setGroups(state, groups: SetPermissionsStateType['groups']) {
      const groupIds = groups.filter((item) => item.isChecked).map((item) => item.id);
      setLocal(STORAGE_KEY.ACTIVE_GROUPS_IDS, groupIds);
      return {
        ...state,
        groups,
      };
    },
    setTableData(state, tableData: TableItetmType[]) {
      return {
        ...state,
        tableData,
      };
    },
  },
  effects: (dispatch) => ({
    async initData(data: string, rootState) {
      const { modifyPerissions = [] } = rootState.DocumentModel;
      const { alertTableData } = rootState.SetPermissionsModel;
      const folderTree = generateFolderTree(modifyPerissions);
      // 如果存在，则优先使用已经保存的
      let tableData: TableItetmType[] = getTableData(folderTree);
      // 根据从哪里来的路由，对表格赋值
      if (data === 'alerTableData') tableData = alertTableData || tableData;
      if (isEmpty(tableData)) return Promise.reject('no data');

      const { rows } = (await Api.request(ApiConfig.getAllGroups, { page: 1, page_size: 999 })) as ApiUserGroupIterface;
      const activeGroupsIds = getLocal(STORAGE_KEY.ACTIVE_GROUPS_IDS, []) as number[];
      const groups = rows.map((item) => ({ ...item, isChecked: activeGroupsIds.includes(item.id) }));

      dispatch.SetPermissionsModel.setState({
        groups,
        tableData,
      });
    },
    async updateFilePermission(payload?: any, rootState?: any) {
      const { groups, tableData } = rootState.SetPermissionsModel;
      const groupKeys = groups.filter((item: any) => item.isChecked).map((item: any) => `${item.id}`);
      const permissions = tableData.reduce((query: any[], tableItem: any) => {
        const effective = Object.keys(tableItem).filter((key) => tableItem.type === 'file' && groupKeys.includes(key));
        const rest = effective.map((key) => ({
          file_id: tableItem.id,
          group_id: parseInt(key, 10),
          action: tableItem[key].action,
        }));
        return [...query, ...rest];
      }, []);
      await Api.request(ApiConfig.postDocPermission, { permissions });
    },
    saveFilePermissionsTothis(payload?: any, rootState?: any) {
      const { tableData = [] } = rootState.SetPermissionsModel;
      dispatch.SetPermissionsModel.setState({ alertTableData: tableData });
    },
  }),
  selectors: (slice) => ({
    activeGroups() {
      const activeGroups = getLocal(STORAGE_KEY.ACTIVE_GROUPS_IDS, []) as number[];
      return slice((document) => document.groups.filter((item) => activeGroups.includes(item.id)));
    },
  }),
});

function getTableData(folderTree: FolderTree[]) {
  const data: Array<TableItetmType> = [];
  const poll = (arrs: FolderTree[]) => {
    arrs.forEach((item) => {
      data.push(item);
      if (item.expand && item.children.length) poll(item.children);
    });
  };
  poll(folderTree);
  return data;
}
export default SetPermissionsModel;
